<template>
    <div class="RiskMannNavbarEmpresaSeleccionada">
        <div v-if="empresa.id && idUsuario" class="row fixed-top bg-light">
            <router-link class="text-decoration-none btn-lg w-100" :to="{ name: 'EmpresaDatosGenerales' }">
                <p class="d-flex justify-content-center align-items-center">
                    <small class="d-flex text-center">
                        <b class="limit-text mt-1" :title="`${empresa.sede} - ${empresa.nombre}`">
                            <i class="fas fa-building"></i>
                            {{ empresa.sede }} - {{ empresa.nombre }}
                        </b>
                        <sup v-if="empresa.verificada">
                            <i class="fas fa-check-circle text-primary ms-1 me-1"></i>
                        </sup>
                    </small>
                </p>
            </router-link>
        </div>
        <SeleccionarEmpresa v-if="esSeleccionar" :empresa="empresa.nombre" />
    </div>
</template>

<script>
import { db, auth } from '@/firebase';
import { doc, onSnapshot } from "firebase/firestore";
import { Modal } from 'bootstrap';
import SeleccionarEmpresa from './SeleccionarEmpresa.vue';
export default {
    name: "RiskMannNavbarEmpresaSeleccionada",

    components: {
        SeleccionarEmpresa
    },

    data() {
        return {
            idUsuario: "",
            empresa: {
                id: "",
                nombre: "",
                verificada: false,
                sede: "",
            },
            esSeleccionar: false,
        };
    },

    async created() {
        this.esModoSinConexion = await this.$store.state.obtenerModoSinConexion();
        if (this.esModoSinConexion) {
            this.$emit("empresaSeleccionada", false);
        } else {
            const usuario = auth.currentUser;
            if (usuario) {
                const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
                if (usuarioDB) {
                    this.idUsuario = usuarioDB.id;
                    await this.obtenerUsuario();
                }
            }
        }
    },

    methods: {
        async obtenerUsuario() {
            onSnapshot(doc(db, "riskmann_usuarios", this.idUsuario), (usuario) => {
                if (usuario.data().preferencias.idEmpresaSeleccionada) {
                    onSnapshot(doc(db, "riskmann_empresa", usuario.data().preferencias.idEmpresaSeleccionada), (empresa) => {
                        if (empresa.data().registro.estado != "Eliminado") {
                            let sede = 'PRINCIPAL'
                            if (empresa.data().nit.consecutivo != 0) {
                                sede = 'SUBESPACIO #' + empresa.data().nit.consecutivo
                            }
                            this.empresa = {
                                id: empresa.id,
                                nombre: empresa.data().razonSocial,
                                verificada: empresa.data().verificada,
                                sede: sede
                            };
                        }
                        else {
                            this.esSeleccionar = true;
                            this.empresa.nombre = empresa.data().razonSocial
                            setTimeout(() => {
                                new Modal(document.getElementById('SeleccionarEmpresa'), {
                                    backdrop: "static"
                                }).show();
                            }, 25)
                        }
                        this.$emit("empresaSeleccionada", true)
                    });
                }
                else {
                    this.empresa = {
                        id: "",
                        nombre: "",
                        verificada: false,
                        sede: ""
                    };
                    this.$emit("empresaSeleccionada", false)
                }
            });
        },
    },
}
</script>

<style scoped>
ion-icon,
small p,
b {
    font-size: 12pt;
    color: #073d7a
}

.fas.fa-check-circle {
    margin-top: 15px;
}

.limit-text {
    text-transform: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

@media screen and (max-width: 576px) {
    .limit-text {
        display: inline-block;
        white-space: nowrap;
        animation: marquee 12s linear infinite;
    }
}

@keyframes marquee {
    0% { transform: translateX(0%); }
    50% { transform: translateX(-25%); }
    100% { transform: translateX(0%); }
}
</style>